import { createAsyncComponent } from '@/utils/factory/createAsyncComponent';
import FullScreen from './FullScreen.vue';

export const UserDropDown = createAsyncComponent(() => import('./user-dropdown/index.vue'), {
  loading: true,
});

export const AppCalling = createAsyncComponent(() => import('./AppCalling.vue'));

export const AppDownImg = createAsyncComponent(() => import('./AppDownImg.vue'));

export const LayoutBreadcrumb = createAsyncComponent(() => import('./Breadcrumb.vue'));

export const Notify = createAsyncComponent(() => import('./notify/index.vue'));

export const ErrorAction = createAsyncComponent(() => import('./ErrorAction.vue'));

export const GoHomeCoMponent = createAsyncComponent(() => import('./GoHome.vue'));

export const EmailIconComponent = createAsyncComponent(() => import('./EmailIcon.vue'));

export const UpdateLogIcon = createAsyncComponent(() => import('./UpdateLogIcon.vue'));

export { FullScreen };
